// extracted by mini-css-extract-plugin
module.exports = {"article":"DetailsViewCardOrderInfo-article-33dKy","container":"DetailsViewCardOrderInfo-container-1o8UU","content":"DetailsViewCardOrderInfo-content-3_5Jv"};